module.exports = __webpack_public_path__ + "img/gameinfo_1_.7d57c482.png";